module.exports = __webpack_public_path__ + "img/wind-turbine.c2ffb742.png";